import { createAsyncThunk } from "@reduxjs/toolkit";
import { type CustomersPage, type SearchCustomersParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const searchCustomers = createAsyncThunk<
  CustomersPage,
  SearchCustomersParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.SEARCH_CUSTOMERS, async (params, { extra }) => {
  return await extra.complianceRepo.searchCustomers(params);
});
